import React from "react";
import { connect } from "react-redux";

import "./PaycheckList.css";

import { getPaychecksList, getPaycheckFile } from "../../../../actions/paycheckActions";

class PaycheckList extends React.Component {
    componentDidMount() {
        this.props.getPaychecksList();
    }

    monthName = month => ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"][month - 1];

    renderPaychecks = () => Object.entries(this.props.paycheckList.reduce((paycheckDict, paycheck) => {
        const paycheckKey = `${paycheck.year}_${paycheck.month}`;
        
        if (!paycheckDict[paycheckKey]) paycheckDict[paycheckKey] = [];
        paycheckDict[paycheckKey].push(paycheck);

        return paycheckDict;
    }, {})).map(([key, paychecks]) => {
        return (
            <React.Fragment key={key}>
                <div className="ui big month header">
                    <div className="content">Paski wynagrodzeń za miesiąc: {this.monthName(paychecks[0].month)} {paychecks[0].year}:</div>
                </div>
                {paychecks.map(paycheck => {
                    return (
                        <div className="ui segment-wrapper" key={paycheck.paycheckID}>
                            <div className="ui segment">
                                <div className="ui grid">
                                    <div className="row">
                                        <div className="eleven wide title column">
                                            <div className="ui big header">{paycheck.title}</div>
                                        </div>
                                        <div className="five wide column">
                                            <div className="content">
                                                <button className="ui primary button" type="button" onClick={() => this.props.getPaycheckFile(paycheck.paycheckID)}>Pobierz</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    );
                })}
            </React.Fragment>
        );
    });

    render() {
        return (
            <React.Fragment>
                <div className="paycheck-list-component ui container">
                    {this.props.paycheckList.length ? (
                        <React.Fragment>
                            <div className="ui large header">
                                <div className="content">Paski wynagrodzeń do pobrania:</div>
                            </div>
                            {this.renderPaychecks()}
                        </React.Fragment>
                    ) : (
                        <div className="ui grid">
                            <div className="column">
                                <h2 className="ui icon header">
                                    <i className="money bill alternate icon"></i>
                                    <div className="content">Nie odnaleziono pasków wynagrodzeń</div>
                                </h2>
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    paycheckList: state.paycheck.list
});

export default connect(mapStateToProps, { getPaychecksList, getPaycheckFile })(PaycheckList);